<template>
  <img
    v-if="icon"
    class="base-icon"
    :class="customClass"
    :src="setIcon(require('@/assets/icons/' + icon + '.svg'))"
    alt
    @click="onClick"
  >
</template>

<script>
/**
 * Base Icon
 */
export default {
  name: 'BaseIcon',
  props: {
    /**
     * This is the name of the image you can find on src/assets/icons
     * It must be a SVG image
     * @values String
     * @see [src/assets/icons](src/assets/icons) for icons available
     */
    icon: {
      type: String,
      required: true,
      default: null,
    },
  },
  computed: {
    customClass() {
      return {
        'base-icon--clickable': this.hasClickListener,
      };
    },
    hasClickListener() {
      return this.$listeners.click || this.$listeners['!click'];
    },
  },
  methods: {
    /** This method is a workaround to [object module] import issue
     * More info: https://github.com/vuejs/vue-loader/issues/1612
     */
    setIcon(icon) {
      return typeof icon === 'object' ? icon.default : icon;
    },
    onClick() {
      if (this.hasClickListener) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.base-icon {
  vertical-align: middle;
  user-select: none;
  -webkit-touch-callout: none;
  &--clickable {
    cursor: pointer;
  }
}
</style>
